import CoreImage from 'core/variables/images';
import PropTypes from 'prop-types';
import React from 'react';

function Image({ alt = '', className = 'image', decorative = false, id = 'logoBig', loading = 'lazy', role = null, src = null, ...props }) {
  const imageSrc = src || CoreImage.getImage(id);
  const isDecorative = decorative || (alt === '' && !role);
  const altText = isDecorative ? '' : alt;

  return (
    <img
      {...props}
      alt={altText}
      className={className}
      loading={loading || 'lazy'}
      src={imageSrc}
      {...(role && { role })}
      {...(isDecorative && { 'aria-hidden': 'true' })}
    />
  );
}

Image.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  decorative: PropTypes.bool,
  id: PropTypes.oneOf([
    'logoBig',
    'logoIconS',
    'noBooks',
    'noItems',
    'noUsers',
    'noQuestions',
    'noCourses',
    'barMenuLogo',
    'logoWhite',
    'noPictureProgram',
    'cover-card-task',
    'cover-card-out-of-time',
    'cover-card-quizz',
    'noMembers',
    'videoContentPreview',
    'login',
    'signup1',
    'signup2',
    'signup3',
    'signup4',
    'signup5',
    'cover-test-started',
    'cover-test-blocked',
    'cover-test-default',
    'cover-test-confirmation',
    'cover-test-formative',
    'cover-test-formative-late',
    'image-layout-progress',
    'cover-card-videolesson',
    'cover-card-audio',
    'cover-card-doc',
    'cover-card-link',
    'cover-card-video',
    'noMaterials',
    'noUnitProgram',
  ]),
  loading: PropTypes.oneOf(['lazy', 'eager']),
  role: PropTypes.string,
  src: PropTypes.string,
};

export default Image;
